export const loaderMessages = {
  DOWNLOAD_MSG:
    "Please wait, preparing requested files for download. This might take some time",
  EXPORT_MSG:
    "Please wait, preparing export of selected items. This might take some time",
  PROCESSING_SYNC_REQUEST: "Processing Sync Request...",
  STARTED_SYNC_PROCESS: "Sync to Quickbooks started, Please wait",
  INIATING_DOWNLOAD: "Processing Download Request...",
  GENERATION_PROCESSING: "Document Generation in Process, Please wait",
  GENERATION_INITATED: "Starting Document Generation...",
  RECALL_IN_PROCESS: "Invoice recall in progress",
  DOWNLOAD_ORIGINAL: "Retrieving original file for download",
  PROCESSING_REQUEST: "Processing Request...",
};

export const REFRESH_WARNING =
  "Refreshing page will cancel export/download?, Do you want to proceed ?";
export const loaderConsts = {
  ERROR: "error",
  COMPLETED: "completed",
  START: "started",
  PROCESSING: "processing",
  SYNC_FAILED_MSG: "Error. QuickBooks sync failed.",
  DOWNLOAD_FAILED: "File downloaded failed",
  DOWNLOAD_SUCCESS: "File downloaded successfully",
  DOCUMENTS_NOT_GENERATED: "Documents are not generated yet. Please try again later",
  DOWNLOAD_BATCH_FAILED: "All Download Batch Documents Failed",
};
